import { styled } from 'theme'

export const SvgWrap = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  svg: {
    path: {
      stroke: '$disabledIcon',
    },
  },
  variants: {
    size: {
      xxs: {
        'svg, img': {
          width: '$size$16',
          height: '$size$16',
        },
      },
      xs: {
        'svg, img': {
          width: '$size$20',
          height: '$size$20',
        },
      },
      sm: {
        'svg, img': {
          width: '$size$24',
          height: '$size$24',
        },
      },
      md: {
        'svg, img': {
          width: '$size$32',
          height: '$size$32',
        },
      },
      xlg: {
        'svg, img': {
          width: '$size$42',
          height: '$size$42',
        },
      },
      lg: {
        'svg, img': {
          width: '$size$48',
          height: '$size$48',
        },
      },
      xl: {
        'svg, img': {
          width: '$size$56',
          height: '$size$56',
        },
      },
      login: {
        'svg, img': {
          width: '$size$48',
          height: '$size$48',
        },
      },
      container: {},
    },

    color: {
      primary: {
        svg: {
          path: {
            stroke: '$primaryBase',
          },
        },
      },
      secondary: {
        svg: {
          path: {
            stroke: '$gray600',
          },
        },
      },
      warning: {
        svg: {
          path: {
            stroke: '$warning600',
          },
        },
      },
      error: {
        svg: {
          path: {
            stroke: '$error600',
          },
        },
      },
      success: {
        svg: {
          path: {
            stroke: '$success600',
          },
        },
      },
      gray: {
        svg: {
          path: {
            stroke: '$titleGray',
          },
        },
      },
      darkGray: {
        svg: {
          path: {
            stroke: '$gray800',
          },
        },
      },
      white: {
        svg: {
          path: {
            stroke: '$whiteBase',
          },
        },
      },
      black: {
        svg: {
          path: {
            stroke: '$blackBase',
          },
        },
      },
      disabled: {
        svg: {
          path: {
            stroke: '$disabledHintIcon',
          },
        },
      },
      transparent: {
        svg: {
          path: {
            stroke: 'transparent',
          },
        },
      },
    },
    background: {
      primary: {
        backgroundColor: '$primary200',
      },
      secondary: {
        backgroundColor: '$gray200',
      },
      gray: {
        backgroundColor: '$gray100',
      },
      warning: {
        backgroundColor: '$warning200',
      },
      error: {
        backgroundColor: '$error200',
      },
      success: {
        backgroundColor: '$success200',
      },
      black: {
        backgroundColor: '$blackBase',
      },
      white: {
        backgroundColor: '$whiteBase',
      },
      disabled: {
        backgroundColor: '$disabledHintIcon',
      },
    },
    fillColor: {
      primary: {
        svg: {
          path: {
            fill: '$primaryBase',
          },
        },
      },
      secondary: {
        svg: {
          path: {
            fill: '$gray600',
          },
        },
      },
      gray: {
        svg: {
          path: {
            fill: '$titleGray',
          },
        },
      },
      warning: {
        svg: {
          path: {
            fill: '$warning600',
          },
        },
      },
      error: {
        svg: {
          path: {
            fill: '$error600',
          },
        },
      },
      success: {
        svg: {
          path: {
            fill: '$success600',
          },
        },
      },
      black: {
        svg: {
          path: {
            fill: '$blackBase',
          },
        },
      },
      white: {
        svg: {
          path: {
            fill: '$whiteBase',
          },
        },
      },
      disabled: {
        svg: {
          path: {
            fill: '$disabledHintIcon',
          },
        },
      },
      transparent: {
        svg: {
          path: {
            fill: 'none',
          },
        },
      },
    },
    border: {
      rounded: {
        borderRadius: '50%',
      },
      sm: {
        borderRadius: '$radii$sm',
        p: '$8',
      },
      none: {
        borderRadius: 'none',
      },
    },
  },
  defaultVariants: {
    color: 'gray',
    size: 'sm',
  },
})
